import { CATEGORY_LABELS, type Category } from "@abejon/shared";

interface BusinessHeaderProps {
  displayName: string;
  category: Category;
  bio: string | null;
  avatarUrl: string | null;
  coverUrl: string | null;
  city: string | null;
  state: string | null;
}

export function BusinessHeader({
  displayName,
  category,
  bio,
  avatarUrl,
  coverUrl,
  city,
  state,
}: BusinessHeaderProps) {
  return (
    <div>
      {/* Cover */}
      <div className="h-40 rounded-xl bg-gray-200 sm:h-52" role="img" aria-label={`${displayName} cover photo`}>
        {coverUrl && (
          <img
            src={coverUrl}
            alt={`${displayName} cover photo`}
            className="h-full w-full rounded-xl object-cover"
          />
        )}
      </div>

      {/* Avatar + Info */}
      <div className="relative px-4">
        <div className="-mt-12 mb-3 flex items-end gap-4">
          <div className="h-24 w-24 flex-shrink-0 rounded-full border-4 border-white bg-gray-300">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={displayName}
                className="h-full w-full rounded-full object-cover"
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center rounded-full bg-gray-900 text-2xl font-bold text-white">
                {displayName.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
        </div>

        <h1 className="text-2xl font-bold">{displayName}</h1>
        <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
          <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium">
            {CATEGORY_LABELS[category]}
          </span>
          {city && state && (
            <span>{city}, {state}</span>
          )}
        </div>
        {bio && <p className="mt-3 text-gray-700">{bio}</p>}
      </div>
    </div>
  );
}
